<template>
  <base-drawer
    :open="drawer.open"
    :close="drawer.close"
    :haveX="false"
    direction="center"
  >
    <span class="close-drawer" @click="closeDrawer()">
      <i class="fal fa-times" />
    </span>

    <!-- <input type="file" id="img_store" /> -->
    <upload-image
      :environment="environment"
      :maxWidth="512"
      :maxHeight="512"
      @setImage="setImageLogo"
    >
      <label for="img_store" class="choose-image">
        <img
          class="rounded"
          v-if="images && images.logo"
          :src="images && getPreviewUrl(images.logo)"
          style="height: 92px; width: auto"
        />
        <div v-else class="icon">
          <i class="fal fa-camera-retro" />
        </div>
        <div class="plus">
          <i class="fal fa-plus fs-12" />
        </div>
      </label>
    </upload-image>

    <p class="store_name">{{ environmentName }}</p>
    <div class="store_url">
      <span>{{ environmentUrl }} </span>
      <div class="copy" @click="copyLink()" :class="{ copied: !!copiedLink }">
        {{ !!copiedLink ? 'Link copiado!' : 'Copiar link' }}
      </div>
    </div>
    <a :href="environmentUrl" target="_blank" class="no-decoration">
      <base-button class="w-100 big mb_15" text="Ver minha loja online" />
    </a>

    <div class="share">
      <a
        class="whatsapp"
        target="_blank"
        :href="`https://wa.me/?text=${encodeURI(wppText)}`"
      >
        <base-button design="five" class="w-100 big mb_15">
          <i class="fab fa-whatsapp fs-12 mr_10" />
          Compartilhar via WhatsApp
        </base-button>
      </a>

      <base-button
        design="five"
        class="w-100 big"
        v-on:click="() => downloadQrCode()"
      >
        <i class="fal fa-qrcode fs-12 mr_10" />
        Baixar QR Code da loja
      </base-button>

      <!-- <base-button design="five" class="w-100 big mb_15" disabled>
        <i class="fal fa-print fs-12 mr_10" />
        Imprimir QR Code da loja
      </base-button> -->
    </div>
  </base-drawer>
</template>

<script>
import Images from '@/plugins/core/schema/configurations/BasicInfo/Images';
import StoreAPI from '@/api/store';
import UploadImage from '@/containers/UploadImage';

import BaseButton from '@/components/Button';
import BaseDrawer from '@/components/Drawer';
import { getXAPIEnv } from '@/plugins/account';
import AppBridge from '@/plugins/app';
import { QRCode } from '@/plugins/qrcode';
import { mapState } from 'vuex';

export default {
  data() {
    const environment = getXAPIEnv();
    const url = process.env.VUE_APP_URL_FRONT;
    const environmentUrl = `${url}/${environment}`;

    return {
      url,
      environment,
      environmentUrl,
      wppText: `Faça seu pedido online diretamente conosco sem precisar instalar nenhum
aplicativo. Acesse ${environmentUrl} e confira.
`,
      urlImage: `${process.env.VUE_APP_IMAGES}/${environment}`,
      imageLogo: null,
      drawer: {
        open: false,
        close: false,
      },
      copiedLink: false,
    };
  },
  components: {
    BaseButton,
    BaseDrawer,
    UploadImage,
  },
  methods: {
    copyLink() {
      if (!AppBridge.isApp())
        navigator.clipboard.writeText(this.environmentUrl);
      else {
        AppBridge.emit('copyStoreLink', this.environmentUrl);
      }
      this.copiedLink = true;
      setTimeout(() => {
        this.copiedLink = false;
      }, 5000);
    },
    downloadQrCode() {
      QRCode.downloadQRCodeImage(
        `qrcode-${this.environment}.png`,
        this.environmentUrl
      );
    },
    openDrawer() {
      this.drawer.open = !this.drawer.open;
    },
    closeDrawer() {
      this.drawer.close = !this.drawer.close;
      this.drawer.open = !this.drawer.open;
      this.copiedLink = false;
    },
    async setImageLogo(fileName) {
      const response = await StoreAPI.storeConfiguration({
        images: {
          ...this.images,
          logo: fileName,
        },
      });

      if (response.getErrors([]).length > 0) {
        alert(StringLanguage.saveError);
      } else {
        this.$store.dispatch('store/getConfigurations');
      }
    },
    getPreviewUrl(image) {
      try {
        let url = new URL(image);
        return image;
      } catch (e) {
        return `${this.urlImage}/${image}`;
      }
    },
  },
  computed: {
    ...mapState({
      environmentName: (state) => state.store.configurations.basic_info.name,
      images: (state) => state.store.configurations.images,
    }),
  },
};
</script>

<style scoped>
.close-drawer {
  font-size: 16px;
  color: var(--icon-inactive);
  margin-bottom: 7px;
  cursor: pointer;
  display: inline-flex;
  position: absolute;
  right: 15px;
}

input[type='file']#img_store {
  opacity: 0;
  position: absolute;
  z-index: -1;
}

label.choose-image {
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--box-up);
  cursor: pointer;
  margin: auto;
  position: relative;
  margin-top: 20px;
}

label.choose-image .icon i {
  color: var(--icon-inactive);
  font-size: 17px;
}

label.choose-image .plus {
  width: 22px;
  height: 22px;
  background: #4e5157;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  right: 3px;
  bottom: 0;
  color: var(--icon-inactive);
}

.store_name {
  color: var(--label-secondary);
  font-size: 16px;
  line-height: 18px;
  margin: auto;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.store_url {
  border: 1px solid #515159;
  background: var(--box);
  border-radius: 5px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  margin-top: 40px;
}

.store_url span {
  color: var(--label-primary);
  font-size: 12px;
  line-height: 15px;
  max-width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.store_url .copy {
  border: 1px solid #999999;
  border-radius: 5px;
  padding: 5px 10px;
  color: var(--label-primary);
  line-height: 15px;
}

.store_url .copy:hover {
  background: #9999993f;
  cursor: pointer;
}

.store_url .copy.copied {
  background: #0dc59d26;
  border: 1px solid transparent;
  color: #0dc59df0;
}

.share {
  border-top: 1px solid #ffffff17;
  padding-top: 20px;
  margin-top: 20px;
}

.share .whatsapp {
  text-decoration: none;
}

.share .whatsapp:focus {
  outline: none;
}

.rounded {
  border-radius: 50%;
  overflow: hidden;
}
</style>
